export type ProjectType = "Corporate" | "Wedding" | "Gift" | "Religious" | "Celebration" | "Personal";

export interface ShowcaseEntry {
  slug: string;
  songName: string;
  clientDisplay: string;
  projectType: ProjectType;
  description: string;
  deliveredAudioUrl: string;
  heroImageUrl: string;
  blogSlug: string;
  rating?: number;
}

const R2_BASE = "https://pub-6c4a08b7a6ba4982b5be067dec180888.r2.dev/brand-blog-images/changelyric";

export const showcaseEntries: ShowcaseEntry[] = [
  {
    slug: "flower-man-deltarune-darkner-lyric-swap",
    songName: "Flower Man (Toby Fox)",
    clientDisplay: "Anthony S.",
    projectType: "Personal",
    description: "Toby Fox's Flower Man from Deltarune Chapter 5 rewritten as Anthony's own Darkner Man anthem. Same voice and melody, with two word transitions re-cut after his notes.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/flower-man-deltarune-darkner-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/flower-man-deltarune-darkner-lyric-swap-hero.webp`,
    blogSlug: "flower-man-deltarune-darkner-lyric-swap",
    rating: 5,
  },
  {
    slug: "thriller-custom-legal-office-lyrics",
    songName: "Thriller (Michael Jackson)",
    clientDisplay: "Cameron Group",
    projectType: "Corporate",
    description: "Michael Jackson's Thriller rebuilt as a law firm anthem: badge scans, stairwell steps, and a chorus about fighting lawsuits and checking redlines late at night. Four masters against the client's second-by-second timing notes.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/thriller-custom-legal-office-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/thriller-custom-legal-office-lyrics-hero.webp`,
    blogSlug: "thriller-custom-legal-office-lyrics",
    rating: 5,
  },
  {
    slug: "father-and-daughter-mother-son-wedding-lyrics",
    songName: "Father and Daughter (Paul Simon)",
    clientDisplay: "Laura R.",
    projectType: "Wedding",
    description: "Paul Simon's Father and Daughter flipped for the mother and son dance: there could never be a mother who loved her Noie more. Two lines changed, first master accepted a few hours later.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/father-and-daughter-mother-son-wedding-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/father-and-daughter-mother-son-wedding-lyrics-hero.webp`,
    blogSlug: "father-and-daughter-mother-son-wedding-lyrics",
    rating: 5,
  },
  {
    slug: "runway-custom-dog-show-lyrics",
    songName: "Runway (Custom Track)",
    clientDisplay: "Raj K.",
    projectType: "Celebration",
    description: "A customer-supplied strut anthem pointed at the dog show ring: dance floor becomes show ring, the judges scream okay, and Jeri gets her growl. Three masters over two revision rounds.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/runway-custom-dog-show-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/runway-custom-dog-show-lyrics-hero.webp`,
    blogSlug: "runway-custom-dog-show-lyrics",
    rating: 5,
  },
  {
    slug: "life-with-you-red-hair-lyric-swap",
    songName: "Life With You (Kelsey Hart)",
    clientDisplay: "Jack D.",
    projectType: "Personal",
    description: "Kelsey Hart's Life With You with one word changed: brown hair became red hair. Two Horizon takes, mono glued into the verse, delivered the next day.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/life-with-you-red-hair-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/life-with-you-red-hair-lyric-swap-hero.webp`,
    blogSlug: "life-with-you-red-hair-lyric-swap",
  },
  {
    slug: "brother-love-caitlin-wedding-lyric-swap",
    songName: "Brother Love's Travelling Salvation Show (Neil Diamond)",
    clientDisplay: "Thomas S.",
    projectType: "Wedding",
    description: "Neil Diamond's revival anthem rewritten for his daughter Caitlin's wedding: the tent became a wedding site, and 'I will never stray' became 'you made my hair gray.' Sung lead on a custom model with gospel-tagged backing vocals.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/brother-love-caitlin-wedding-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/brother-love-caitlin-wedding-lyric-swap-hero.webp`,
    blogSlug: "brother-love-caitlin-wedding-lyric-swap",
    rating: 5,
  },
  {
    slug: "ballad-for-beelzebub-custom-team-lyrics",
    songName: "Ballad for Beelzebub (Graveyard Train)",
    clientDisplay: "Brendan O.",
    projectType: "Celebration",
    description: "Graveyard Train's gig-in-hell anthem rebuilt for a sports team's training grind: weights, cones, and a coach who keeps sending you back up. Built section by section for the layered vocals, with a same-day turnaround on the final fix.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ballad-for-beelzebub-custom-team-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ballad-for-beelzebub-custom-team-lyrics-hero.webp`,
    blogSlug: "ballad-for-beelzebub-custom-team-lyrics",
    rating: 5,
  },
  {
    slug: "ymca-custom-party-lyrics",
    songName: "Y.M.C.A. (Village People)",
    clientDisplay: "David M.",
    projectType: "Celebration",
    description: "The Village People's Y.M.C.A. turned into a bock beer party anthem for the O.T.R. Bars: pull your stein off the shelf, and no man should drink all by himself. Full stem rebuild with the spelling chant intact.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ymca-custom-party-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ymca-custom-party-lyrics-hero.webp`,
    blogSlug: "ymca-custom-party-lyrics",
    rating: 5,
  },
  {
    slug: "my-way-custom-70th-birthday-lyrics",
    songName: "My Way (Frank Sinatra)",
    clientDisplay: "Mandy T.",
    projectType: "Gift",
    description: "Sinatra's My Way rewritten as a 70th birthday roast for Bags: Wimpy stops, Harley rides, mensch energy, and Mazeltov. Produced by Calvin with two rounds of pronunciation-perfecting revisions.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/my-way-custom-70th-birthday-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/my-way-custom-70th-birthday-lyrics-hero.webp`,
    blogSlug: "my-way-custom-70th-birthday-lyrics",
    rating: 5,
  },
  {
    slug: "rama-lama-ding-dong-cama-name-swap",
    songName: "Rama Lama Ding Dong (The Edsels)",
    clientDisplay: "Vito C.",
    projectType: "Personal",
    description: "The Edsels' 1958 doo-wop classic with every rama turned into cama, so the hook itself serenades a girl named Cama. Delivered clean in four days with no revisions needed.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/rama-lama-ding-dong-cama-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/rama-lama-ding-dong-cama-name-swap-hero.webp`,
    blogSlug: "rama-lama-ding-dong-cama-name-swap",
    rating: 5,
  },
  {
    slug: "you-get-what-you-give-church-stewardship-lyrics",
    songName: "You Get What You Give (New Radicals)",
    clientDisplay: "Molly M.",
    projectType: "Religious",
    description: "The New Radicals' You Get What You Give rewritten as a church stewardship anthem: 'the music in you' became 'the giving in you.' Rebuilt on the shorter radio edit after two rounds of revision notes, with a five star review.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/you-get-what-you-give-church-stewardship-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/you-get-what-you-give-church-stewardship-lyrics-hero.webp`,
    blogSlug: "you-get-what-you-give-church-stewardship-lyrics",
    rating: 5,
  },
  {
    slug: "angel-of-mine-husband-50th-birthday-lyrics",
    songName: "Angel of Mine (Monica)",
    clientDisplay: "Rachel B.",
    projectType: "Celebration",
    description: "Monica's Angel of Mine rewritten as Husband of Mine for a 50th birthday: cricket whites, wasabi, and weekends lost to the game. Two revision rounds and a five star review.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/angel-of-mine-husband-50th-birthday-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/angel-of-mine-husband-50th-birthday-lyrics-hero.webp`,
    blogSlug: "angel-of-mine-husband-50th-birthday-lyrics",
    rating: 5,
  },
  {
    slug: "september-custom-celebration-gift-lyrics",
    songName: "September (Earth, Wind & Fire)",
    clientDisplay: "Gayle B.",
    projectType: "Gift",
    description: "Earth, Wind & Fire's September pointed at one real night: the twentieth of September, celebrating Kim. Delivered with one revision to make the date land clearly.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/september-custom-celebration-gift-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/september-custom-celebration-gift-lyrics-hero.webp`,
    blogSlug: "september-custom-celebration-gift-lyrics",
    rating: 5,
  },
  {
    slug: "the-idiot-wildland-firefighter-custom-lyrics",
    songName: "The Idiot (Stan Rogers)",
    clientDisplay: "Krystal Z.",
    projectType: "Personal",
    description: "Stan Rogers' The Idiot turned from refinery work to the smoke and steep mountains of a wildland firefighter, with a male lead vocal on the full master.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/the-idiot-wildland-firefighter-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/the-idiot-wildland-firefighter-custom-lyrics-hero.webp`,
    blogSlug: "the-idiot-wildland-firefighter-custom-lyrics",
    rating: 5,
  },
  {
    slug: "ballroom-blitz-custom-team-kickoff-lyrics",
    songName: "Ballroom Blitz (Sweet)",
    clientDisplay: "Dorinda H.",
    projectType: "Corporate",
    description: "Sweet's Ballroom Blitz reworked as a private group event kickoff, calling every participant by name with a beat to answer before alright warriors let's go.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ballroom-blitz-custom-team-kickoff-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ballroom-blitz-custom-team-kickoff-lyrics-hero.webp`,
    blogSlug: "ballroom-blitz-custom-team-kickoff-lyrics",
    rating: 5,
  },
  {
    slug: "youre-beautiful-wedding-gift-lyric-swap",
    songName: "You're Beautiful (James Blunt)",
    clientDisplay: "Joanne O.",
    projectType: "Wedding",
    description: "A wedding gift 30 years in the making: James Blunt's You're Beautiful with the couple's own changed line, 'I'm so in oops with you,' finally on record as a surprise from the bride's best friend.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/youre-beautiful-wedding-gift-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/youre-beautiful-wedding-gift-lyric-swap-hero.webp`,
    blogSlug: "youre-beautiful-wedding-gift-lyric-swap",
    rating: 5,
  },
  {
    slug: "dentist-little-shop-of-horrors-manager-parody",
    songName: "Dentist! (Little Shop of Horrors)",
    clientDisplay: "Ingo B.",
    projectType: "Personal",
    description: "Little Shop of Horrors' Dentist! rewritten so the menace is an office manager instead, from leader of the plaque to leader of the pack. Reassigned and rebuilt after the first pass missed, and the final master earned a five star review.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/dentist-little-shop-of-horrors-manager-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/dentist-little-shop-of-horrors-manager-parody-hero.webp`,
    blogSlug: "dentist-little-shop-of-horrors-manager-parody",
    rating: 5,
  },
  {
    slug: "beauty-and-the-beast-cousin-birthday-gift-lyrics",
    songName: "Beauty and the Beast (Disney)",
    clientDisplay: "Matthias W.",
    projectType: "Gift",
    description: "Every line of Disney's Beauty and the Beast rewritten into a friendship anthem for a cousin's birthday, certificate gag and all, delivered with clean stems and a full remix inside two days.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/beauty-and-the-beast-cousin-birthday-gift-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/beauty-and-the-beast-cousin-birthday-gift-lyrics-hero.webp`,
    blogSlug: "beauty-and-the-beast-cousin-birthday-gift-lyrics",
    rating: 5,
  },
  {
    slug: "lights-journey-custom-name-swap",
    songName: "Lights (Journey)",
    clientDisplay: "Noreen K.",
    projectType: "Personal",
    description: "Journey's Lights with the bay changed to Rumi in all three chorus hooks. One revision stretched the name to ride the original cadence, and the final master was accepted two days after payment.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/lights-journey-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/lights-journey-custom-name-swap-hero.webp`,
    blogSlug: "lights-journey-custom-name-swap",
  },
  {
    slug: "7-rings-gratitude-mindset-lyrics",
    songName: "7 rings (Ariana Grande)",
    clientDisplay: "FM E.",
    projectType: "Personal",
    description: "Ariana Grande's 7 rings flipped from retail flex to gratitude, blessings, and Pilates, with the interlude and skit sections cut from the master. Delivered two days after payment with stems included.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/7-rings-gratitude-mindset-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/7-rings-gratitude-mindset-lyrics-hero.webp`,
    blogSlug: "7-rings-gratitude-mindset-lyrics",
  },
  {
    slug: "supernatural-custom-name-swap",
    songName: "supernatural (Ariana Grande)",
    clientDisplay: "FM E.",
    projectType: "Gift",
    description: "Ariana Grande's supernatural personalized for a customer's partner: the name JZ inserted into two intimate lines and every chorus shifted from this love to your love, delivered in about 28 hours.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/supernatural-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/supernatural-custom-name-swap-hero.webp`,
    blogSlug: "supernatural-custom-name-swap",
  },
  {
    slug: "fluorescent-adolescent-brother-wedding-lyrics",
    songName: "Fluorescent Adolescent (Arctic Monkeys)",
    clientDisplay: "Olivia D.",
    projectType: "Wedding",
    description: "Siblings rewrote Arctic Monkeys' Fluorescent Adolescent as a roast of the groom for their brother's wedding, basement days and all.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/fluorescent-adolescent-brother-wedding-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/fluorescent-adolescent-brother-wedding-lyrics-hero.webp`,
    blogSlug: "fluorescent-adolescent-brother-wedding-lyrics",
  },
  {
    slug: "rock-creek-park-37-park-swap",
    songName: "Rock Creek Park (The Blackbyrds)",
    clientDisplay: "Terry N.",
    projectType: "Personal",
    description: "The Blackbyrds' Rock Creek Park re-sung as 37 Park for the opening refrains. Full and trimmed versions delivered about 31 hours after checkout.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/rock-creek-park-37-park-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/rock-creek-park-37-park-swap-hero.webp`,
    blogSlug: "rock-creek-park-37-park-swap",
  },
  {
    slug: "youre-the-one-that-i-want-chef-jeff-tribute",
    songName: "You're The One That I Want (Grease)",
    clientDisplay: "Lisa R.",
    projectType: "Personal",
    description: "The Grease duet reworked into a comic kitchen tribute, with every \"ho, ho, ho honey\" turned into a Chef Jeff punchline.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/youre-the-one-that-i-want-chef-jeff-tribute-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/youre-the-one-that-i-want-chef-jeff-tribute-hero.webp`,
    blogSlug: "youre-the-one-that-i-want-chef-jeff-tribute",
  },
  {
    slug: "la-recette-french-couple-toast-lyrics",
    songName: "La Recette (Jeck & Carla)",
    clientDisplay: "Raphael R.",
    projectType: "Celebration",
    description: "A French love song by Jeck & Carla rewritten as a toast to a couple, with every chorus turned from toi et moi to Clemence and Thomas. Refined through two rounds of customer feedback before final delivery.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/la-recette-french-couple-toast-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/la-recette-french-couple-toast-lyrics-hero.webp`,
    blogSlug: "la-recette-french-couple-toast-lyrics",
  },
  {
    slug: "venus-21st-birthday-flashmob-lyrics",
    songName: "Venus (Bananarama)",
    clientDisplay: "Valeria L.",
    projectType: "Celebration",
    description: "A surprise 21st birthday flashmob needed Bananarama's Venus to sing about Tomas instead of a goddess. One render, one pronunciation fix, and a DJ ready master.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/venus-21st-birthday-flashmob-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/venus-21st-birthday-flashmob-lyrics-hero.webp`,
    blogSlug: "venus-21st-birthday-flashmob-lyrics",
  },
  {
    slug: "roaring-on-gatsby-60th-birthday-lyrics",
    songName: "Roaring On (The Great Gatsby)",
    clientDisplay: "Lena C.",
    projectType: "Celebration",
    description: "A full rewrite of Roaring On from The Great Gatsby musical for a 60th birthday speakeasy, moving the party from Manhattan to Queensland with the Broadway cast sound intact.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/roaring-on-gatsby-60th-birthday-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/roaring-on-gatsby-60th-birthday-lyrics-hero.webp`,
    blogSlug: "roaring-on-gatsby-60th-birthday-lyrics",
  },
  {
    slug: "i-love-kanye-dj-roast-parody",
    songName: "I Love Kanye (Kanye West)",
    clientDisplay: "Marco M.",
    projectType: "Personal",
    description: "The first verse of Kanye West's I Love Kanye becomes a roast of a DJ who traded dark tech house for rap beats. The rest of the song stays untouched, and the joke lands harder for it.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/i-love-kanye-dj-roast-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/i-love-kanye-dj-roast-parody-hero.webp`,
    blogSlug: "i-love-kanye-dj-roast-parody",
  },
  {
    slug: "call-me-maybe-fellowship-graduation-lyrics",
    songName: "Call Me Maybe (Carly Rae Jepsen)",
    clientDisplay: "Yvonne O.",
    projectType: "Celebration",
    description: "Carly Rae Jepsen's Call Me Maybe rewritten as a farewell for graduating ophthalmology fellows, with every name checked against the customer's own pronunciation memo.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/call-me-maybe-fellowship-graduation-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/call-me-maybe-fellowship-graduation-lyrics-hero.webp`,
    blogSlug: "call-me-maybe-fellowship-graduation-lyrics",
  },
  {
    slug: "espresso-car-culture-parody-lyrics",
    songName: "Espresso (Sabrina Carpenter)",
    clientDisplay: "Zane D.",
    projectType: "Personal",
    description: "Sabrina Carpenter's Espresso rewritten as Cappuccino, a car tuning parody full of Miata and turbo jokes that keeps the original's flirty strut.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/espresso-car-culture-parody-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/espresso-car-culture-parody-lyrics-hero.webp`,
    blogSlug: "espresso-car-culture-parody-lyrics",
  },
  {
    slug: "freed-from-desire-seals-on-fire-parody",
    songName: "Freed from Desire (Gala)",
    clientDisplay: "Matevz K.",
    projectType: "Personal",
    description: "A parody swap that rewrites Gala's Freed from Desire as a seal uprising battle anthem. Only the opening verse and chorus change, from Freed from desire to Seals are on fire.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/freed-from-desire-seals-on-fire-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/freed-from-desire-seals-on-fire-parody-hero.webp`,
    blogSlug: "freed-from-desire-seals-on-fire-parody",
  },
  {
    slug: "emmenez-moi-french-food-parody-lyrics",
    songName: "Emmenez-moi (Charles Aznavour)",
    clientDisplay: "Isabelle D.",
    projectType: "Personal",
    description: "A 1967 Aznavour escape fantasy rerouted from the ends of the earth to a restaurant table, with a French pronunciation revision round.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/emmenez-moi-french-food-parody-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/emmenez-moi-french-food-parody-lyrics-hero.webp`,
    blogSlug: "emmenez-moi-french-food-parody-lyrics",
  },
  {
    slug: "brady-bunch-theme-home-listing-anthem",
    songName: "The Brady Bunch Theme (The Peppermint Trolley Company)",
    clientDisplay: "Benjamin R.",
    projectType: "Corporate",
    description: "The Brady Bunch theme rewritten as the origin story of a renovated home, from worn-out windows to a market-ready listing. The famous closing line becomes \"That's the way we all found the Lewis house.\"",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/brady-bunch-theme-home-listing-anthem-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/brady-bunch-theme-home-listing-anthem-hero.webp`,
    blogSlug: "brady-bunch-theme-home-listing-anthem",
  },
  {
    slug: "whos-gonna-fill-their-shoes-baw-crew-parody",
    songName: "Who's Gonna Fill Their Shoes (George Jones)",
    clientDisplay: "Brett B.",
    projectType: "Personal",
    description: "George Jones's salute to country legends became an anthem for one friend crew, with B A W spelled out letter by letter in the vocal.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/whos-gonna-fill-their-shoes-baw-crew-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/whos-gonna-fill-their-shoes-baw-crew-parody-hero.webp`,
    blogSlug: "whos-gonna-fill-their-shoes-baw-crew-parody",
  },
  {
    slug: "shining-star-shawnie-name-swap",
    songName: "Shining Star (The Manhattans)",
    clientDisplay: "James C.",
    projectType: "Personal",
    description: "The Manhattans' Shining Star with every Honey changed to Shawnie, hand sung by the producer and blended into the original lead vocal.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/shining-star-shawnie-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/shining-star-shawnie-name-swap-hero.webp`,
    blogSlug: "shining-star-shawnie-name-swap",
  },
  {
    slug: "ymca-coast-guard-send-off-lyrics",
    songName: "Y.M.C.A. (Village People)",
    clientDisplay: "Brittney P.",
    projectType: "Celebration",
    description: "The Village People's Y.M.C.A. rewritten as a U.S.C.G. anthem for a son leaving for Coast Guard boot camp, with new family verses and the ending trimmed to land on success is in sight.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ymca-coast-guard-send-off-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ymca-coast-guard-send-off-lyrics-hero.webp`,
    blogSlug: "ymca-coast-guard-send-off-lyrics",
  },
  {
    slug: "aicha-khaled-custom-name-swap",
    songName: "Aicha (Cheb Khaled)",
    clientDisplay: "Vinesh L.",
    projectType: "Personal",
    description: "Cheb Khaled's Aicha personalized by swapping every Aicha for Neesha across the full song, refined through a revision round to land the new name cleanly.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/aicha-khaled-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/aicha-khaled-custom-name-swap-hero.webp`,
    blogSlug: "aicha-khaled-custom-name-swap",
    rating: 5,
  },
  {
    slug: "tokyo-dwin-high-to-fly-lyric-swap",
    songName: "Tokyo (Dwin)",
    clientDisplay: "Trevor N.",
    projectType: "Personal",
    description: "Dwin's EDM travel anthem Tokyo with one stealth word swapped, high to fly, so the change sits undetectable inside the original vocal.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/tokyo-dwin-high-to-fly-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/tokyo-dwin-high-to-fly-lyric-swap-hero.webp`,
    blogSlug: "tokyo-dwin-high-to-fly-lyric-swap",
    rating: 5,
  },
  {
    slug: "god-is-a-woman-custom-name-swap",
    songName: "God is a Woman (Ariana Grande)",
    clientDisplay: "Alex L.",
    projectType: "Personal",
    description: "Ariana Grande's God is a Woman with a two-name swap, God to Mark in the hook and the verse lines to JZ, built on the audio-only cut so the interlude never enters.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/god-is-a-woman-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/god-is-a-woman-custom-name-swap-hero.webp`,
    blogSlug: "god-is-a-woman-custom-name-swap",
    rating: 5,
  },
  {
    slug: "hey-there-delilah-custom-name-swap",
    songName: "Hey There Delilah (Plain White T's)",
    clientDisplay: "Kirby N.",
    projectType: "Gift",
    description: "Plain White T's Hey There Delilah personalized with every Delilah swapped for Nadela. Same melody, a new name throughout.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/hey-there-delilah-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/hey-there-delilah-custom-name-swap-hero.webp`,
    blogSlug: "hey-there-delilah-custom-name-swap",
    rating: 5,
  },
  {
    slug: "take-me-home-country-roads-pool-party-parody",
    songName: "Take Me Home, Country Roads (John Denver)",
    clientDisplay: "Lynda B.",
    projectType: "Celebration",
    description: "John Denver's Country Roads rewritten from West Virginia mountains into a sun-soaked pool party parody. Coolers, cheese puffs, and belly flops.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/take-me-home-country-roads-pool-party-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/take-me-home-country-roads-pool-party-parody-hero.webp`,
    blogSlug: "take-me-home-country-roads-pool-party-parody",
    rating: 5,
  },
  {
    slug: "basique-orelsan-wedding-lyric-swap",
    songName: "Basique (Orelsan)",
    clientDisplay: "Guenault T.",
    projectType: "Wedding",
    description: "Orelsan's French rap Basique rewritten bar by bar into a deadpan wedding anthem, keeping the original 'basique' hook intact.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/basique-orelsan-wedding-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/basique-orelsan-wedding-lyric-swap-hero.webp`,
    blogSlug: "basique-orelsan-wedding-lyric-swap",
    rating: 5,
  },
  {
    slug: "something-to-lose-brown-eyes-lyric-swap",
    songName: "Something to Lose (Stella Lefty and Vincent Mason)",
    clientDisplay: "Christy D.",
    projectType: "Personal",
    description: "Something to Lose personalized line by line, swapping 'blue eyes' for 'brown eyes' throughout. Same melody, one word moved.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/something-to-lose-brown-eyes-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/something-to-lose-brown-eyes-lyric-swap-hero.webp`,
    blogSlug: "something-to-lose-brown-eyes-lyric-swap",
    rating: 5,
  },
  {
    slug: "georgia-on-my-mind-larisa-name-swap",
    songName: "Georgia on My Mind",
    clientDisplay: "Mark M.",
    projectType: "Gift",
    description: "The standard Georgia on My Mind personalized by swapping every 'Georgia' for 'Larisa.' Same melody, a new name at the center.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/georgia-on-my-mind-larisa-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/georgia-on-my-mind-larisa-name-swap-hero.webp`,
    blogSlug: "georgia-on-my-mind-larisa-name-swap",
    rating: 5,
  },
  {
    slug: "satisfied-hamilton-wedding-name-swap",
    songName: "Satisfied (from Hamilton)",
    clientDisplay: "Andy W.",
    projectType: "Wedding",
    description: "Hamilton's Satisfied personalized for a real wedding, swapping the maid of honor's name through every line of the toast.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/satisfied-hamilton-wedding-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/satisfied-hamilton-wedding-name-swap-hero.webp`,
    blogSlug: "satisfied-hamilton-wedding-name-swap",
    rating: 5,
  },
  {
    slug: "back-where-i-come-from-philadelphia-lyric-swap",
    songName: "Back Where I Come From (Kenny Chesney)",
    clientDisplay: "Craig M.",
    projectType: "Personal",
    description: "Kenny Chesney's Back Where I Come From relocated line by line from rural Tennessee into a Philadelphia hometown anthem. Scrapple, cheesesteaks, and the Eagles.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/back-where-i-come-from-philadelphia-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/back-where-i-come-from-philadelphia-lyric-swap-hero.webp`,
    blogSlug: "back-where-i-come-from-philadelphia-lyric-swap",
  },
  {
    slug: "time-after-time-compliance-parody-lyrics",
    songName: "Time After Time (Cyndi Lauper)",
    clientDisplay: "Graham S.",
    projectType: "Corporate",
    description: "Cyndi Lauper's Time After Time reworked into a workplace compliance and risk anthem. The devotion chorus becomes professional diligence.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/time-after-time-compliance-parody-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/time-after-time-compliance-parody-lyrics-hero.webp`,
    blogSlug: "time-after-time-compliance-parody-lyrics",
    rating: 5,
  },
  {
    slug: "sister-christian-brother-birthday-tribute",
    songName: "Sister Christian (Night Ranger)",
    clientDisplay: "Kavita V.",
    projectType: "Celebration",
    description: "Night Ranger's Sister Christian rewritten as Brother Vivek, a tennis birthday tribute for a sibling. The road imagery becomes serving and volleys.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/sister-christian-brother-birthday-tribute-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/sister-christian-brother-birthday-tribute-hero.webp`,
    blogSlug: "sister-christian-brother-birthday-tribute",
    rating: 5,
  },
  {
    slug: "i-want-you-back-rinoo-name-swap",
    songName: "I Want You Back (The Jackson 5)",
    clientDisplay: "Nordine B.",
    projectType: "Gift",
    description: "The Jackson 5's I Want You Back with every 'baby' swapped for one name. A clean romantic name swap that keeps the original pleading tone.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/i-want-you-back-rinoo-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/i-want-you-back-rinoo-name-swap-hero.webp`,
    blogSlug: "i-want-you-back-rinoo-name-swap",
    rating: 5,
  },
  {
    slug: "perfect-ed-sheeran-blended-family-lyrics",
    songName: "Perfect (Ed Sheeran)",
    clientDisplay: "Jeffrey C.",
    projectType: "Gift",
    description: "Ed Sheeran's 'Perfect' with subtle lyric changes for a blended family. 'Children of our own' becomes 'children not her own,' telling a story of chosen love.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/perfect-ed-sheeran-blended-family-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/perfect-ed-sheeran-blended-family-lyrics-hero.webp`,
    blogSlug: "perfect-ed-sheeran-blended-family-lyrics",
  },
  {
    slug: "grandpa-grandma-name-swap-judds",
    songName: "Grandpa (The Judds)",
    clientDisplay: "Kristy S.",
    projectType: "Gift",
    description: "The Judds' nostalgic ballad with 'Grandpa' swapped to 'Grandma' throughout. A simple name swap that redirects the song from grandfather to grandmother.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/grandpa-grandma-name-swap-judds-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/grandpa-grandma-name-swap-judds-hero.webp`,
    blogSlug: "grandpa-grandma-name-swap-judds",
  },
  {
    slug: "you-to-me-are-everything-custom-wedding-lyrics",
    songName: "You To Me Are Everything (The Real Thing)",
    clientDisplay: "Martin F.",
    projectType: "Wedding",
    description: "The Real Thing's soul classic rewritten with wedding vow lyrics. Two revision rounds to perfect the vocal phrasing and pitch for Martin's ceremony.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/you-to-me-are-everything-custom-wedding-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/you-to-me-are-everything-custom-wedding-lyrics-hero.webp`,
    blogSlug: "you-to-me-are-everything-custom-wedding-lyrics",
  },
  {
    slug: "i-want-to-hold-joann-custom-name-swap",
    songName: "I Want To Hold Your Hand (The Beatles)",
    clientDisplay: "Gerald E.",
    projectType: "Gift",
    description: "The Beatles' classic love song with 'your hand' swapped to 'JoAnn' throughout. A simple name swap that turns a universal love song into a personal message.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/i-want-to-hold-joann-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/i-want-to-hold-joann-custom-name-swap-hero.webp`,
    blogSlug: "i-want-to-hold-joann-custom-name-swap",
  },
  {
    slug: "thank-you-for-the-stoodies-studebaker-parody",
    songName: "Thank You For The Music (ABBA)",
    clientDisplay: "Gary S.",
    projectType: "Personal",
    description: "ABBA's beloved classic transformed into a Studebaker car club anthem. Every reference to music becomes a nod to classic Studebaker models like the Lark and Golden Hawk.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/thank-you-for-the-stoodies-studebaker-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/thank-you-for-the-stoodies-studebaker-parody-hero.webp`,
    blogSlug: "thank-you-for-the-stoodies-studebaker-parody",
    rating: 5,
  },
  {
    slug: "north-melbourne-theme-song-custom-footy-anthem",
    songName: "North Melbourne Theme Song",
    clientDisplay: "Kyle",
    projectType: "Celebration",
    description: "The North Melbourne Football Club theme song reworked for the Moorabbin team. Every North Melbourne line becomes Moorabbin, and the closing line turns into a premiership prediction.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/north-melbourne-theme-song-custom-footy-anthem-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/north-melbourne-theme-song-custom-footy-anthem-hero.webp`,
    blogSlug: "north-melbourne-theme-song-custom-footy-anthem",
  },
  {
    slug: "bohemian-rhapsody-vc-parody-point-nine",
    songName: "Bohemian Rhapsody (Queen)",
    clientDisplay: "Christoph J.",
    projectType: "Corporate",
    description: "Queen's legendary operatic masterpiece completely rewritten as a venture capital parody for Point Nine. A six minute epic featuring SaaS, AI, DPI, ARR, and IPO references throughout.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/bohemian-rhapsody-vc-parody-point-nine-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/bohemian-rhapsody-vc-parody-point-nine-hero.webp`,
    blogSlug: "bohemian-rhapsody-vc-parody-point-nine",
    rating: 5,
  },
  {
    slug: "thought-you-should-know-custom-lyrics",
    songName: "Thought You Should Know (Morgan Wallen)",
    clientDisplay: "Brandon S.",
    projectType: "Wedding",
    description: "Morgan Wallen's heartfelt country hit personalized for a wedding. Jefferson City becomes San Antonio, the timeline shifts to 1997, and the language softens for a celebration.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/thought-you-should-know-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/thought-you-should-know-custom-lyrics-hero.webp`,
    blogSlug: "thought-you-should-know-custom-lyrics",
    rating: 5,
  },
  {
    slug: "mercury-blues-oldsmobile-swap",
    songName: "Mercury Blues (Alan Jackson)",
    clientDisplay: "Robert T.",
    projectType: "Personal",
    description: "Alan Jackson's classic car anthem transformed from Mercury to Oldsmobile. Twenty two segments changed, including the iconic Mercury 49 becoming Rocket 88.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/mercury-blues-oldsmobile-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/mercury-blues-oldsmobile-swap-hero.webp`,
    blogSlug: "mercury-blues-oldsmobile-swap",
    rating: 5,
  },
  {
    slug: "beautiful-boy-austin-name-swap",
    songName: "Beautiful Boy (John Lennon)",
    clientDisplay: "Brandon S.",
    projectType: "Gift",
    description: "John Lennon's tender lullaby with one simple change. Sean becomes Austin in the final seconds, making the song personal without touching a single other word.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/beautiful-boy-austin-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/beautiful-boy-austin-name-swap-hero.webp`,
    blogSlug: "beautiful-boy-austin-name-swap",
    rating: 5,
  },
  {
    slug: "im-gonna-be-500-miles-corporate-tractor-anthem",
    songName: "I'm Gonna Be (500 Miles)",
    clientDisplay: "PFG USA",
    projectType: "Corporate",
    description: "The Proclaimers' classic love song transformed into a tractor sales anthem for PFG USA. Walking 500 miles becomes selling 5000 tractors, with John Deere and Deutz brand mentions woven throughout.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/im-gonna-be-500-miles-corporate-tractor-anthem-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/im-gonna-be-500-miles-corporate-tractor-anthem-hero.webp`,
    blogSlug: "im-gonna-be-500-miles-corporate-tractor-anthem",
    rating: 5,
  },
  {
    slug: "hallelujah-vikidoo-jeff-buckley-lyric-swap",
    songName: "Hallelujah (Jeff Buckley)",
    clientDisplay: "Arthur H.",
    projectType: "Celebration",
    description: "Jeff Buckley's iconic Hallelujah completely rewritten as 'Vikidoo,' a personalized tribute. Features a rare competitor comparison: ChangeLyric's version beat SongRetold (formerly AI Music Service), though Buckley's voice ultimately proved too difficult for any AI to fully replicate.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/hallelujah-vikidoo-jeff-buckley-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/hallelujah-vikidoo-jeff-buckley-lyric-swap-hero.webp`,
    blogSlug: "hallelujah-vikidoo-jeff-buckley-lyric-swap",
    rating: 5,
  },
  {
    slug: "special-death-lyric-adaptation-english",
    songName: "Special Death (Mirah)",
    clientDisplay: "Eva N.",
    projectType: "Personal",
    description: "Mirah's Special Death adapted with custom English lyrics requiring vocal pacing adjustments. A case study showing how detailed feedback transformed the first version into a polished result.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/special-death-lyric-adaptation-english-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/special-death-lyric-adaptation-english-hero.webp`,
    blogSlug: "special-death-lyric-adaptation-english",
    rating: 4,
  },
  {
    slug: "the-reason-wedding-first-dance-lyrics",
    songName: "The Reason (Hoobastank)",
    clientDisplay: "Audrey R.",
    projectType: "Wedding",
    description: "Hoobastank's apology anthem transformed into a wedding vow for a first dance, flipping the narrative from regret to hope.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/the-reason-wedding-first-dance-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/the-reason-wedding-first-dance-lyrics-hero.webp`,
    blogSlug: "the-reason-wedding-first-dance-lyrics",
    rating: 5,
  },
  {
    slug: "proud-of-your-boy-mother-son-wedding-dance",
    songName: "Proud of Your Boy (Aladdin)",
    clientDisplay: "Margaret S.",
    projectType: "Wedding",
    description: "Aladdin's apology to his mother completely rewritten as a mother's celebration of her son for a wedding dance.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/proud-of-your-boy-mother-son-wedding-dance-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/proud-of-your-boy-mother-son-wedding-dance-hero.webp`,
    blogSlug: "proud-of-your-boy-mother-son-wedding-dance",
    rating: 5,
  },
  {
    slug: "get-up-10-custom-personal-lyrics",
    songName: "Get Up 10 (Cardi B)",
    clientDisplay: "Gregory F.",
    projectType: "Personal",
    description: "Cardi B's autobiographical anthem completely rewritten as a personalized story of hardship and triumph.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/get-up-10-custom-personal-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/get-up-10-custom-personal-lyrics-hero.webp`,
    blogSlug: "get-up-10-custom-personal-lyrics",
    rating: 5,
  },
  {
    slug: "we-didnt-start-the-fire-tech-parody-lyrics",
    songName: "We Didn't Start the Fire (Billy Joel)",
    clientDisplay: "Amanda P.",
    projectType: "Personal",
    description: "Billy Joel's rapid fire history lesson completely rewritten as a tech and AI culture parody. Sixty one segments changed with precise syllable matching.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/we-didnt-start-the-fire-tech-parody-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/we-didnt-start-the-fire-tech-parody-lyrics-hero.webp`,
    blogSlug: "we-didnt-start-the-fire-tech-parody-lyrics",
    rating: 5,
  },
  {
    slug: "the-day-that-i-die-custom-memorial-lyrics",
    songName: "The Day That I Die (Lewis Capaldi)",
    clientDisplay: "Emma W.",
    projectType: "Gift",
    description: "Lewis Capaldi's emotional ballad about loss transformed for a friend who lost her brother. A single word change that shifts the entire song's perspective.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/the-day-that-i-die-custom-memorial-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/the-day-that-i-die-custom-memorial-lyrics-hero.webp`,
    blogSlug: "the-day-that-i-die-custom-memorial-lyrics",
    rating: 5,
  },
  {
    slug: "yellow-submarine-kombi-van-custom-lyrics",
    songName: "Yellow Submarine (The Beatles)",
    clientDisplay: "Tony M.",
    projectType: "Personal",
    description: "The Beatles' classic Yellow Submarine fully rewritten as Yellow Kombi Van. A playful parody that keeps the original's joy while swapping every nautical reference for camper van culture.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/yellow-submarine-kombi-van-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/yellow-submarine-kombi-van-custom-lyrics-hero.webp`,
    blogSlug: "yellow-submarine-kombi-van-custom-lyrics",
    rating: 5,
  },
  {
    slug: "mexico-lindo-y-querido-custom-spanish-lyric-swap",
    songName: "Mexico Lindo y Querido (Vicente Fernandez)",
    clientDisplay: "Bruno",
    projectType: "Personal",
    description: "Vicente Fernandez's beloved Mexican ranchera reborn as an Argentine homage. A Spanish-language swap that leaned on the V3 engine plus a custom voice model trained on the original lead vocalist.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/mexico-lindo-y-querido-custom-spanish-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/mexico-lindo-y-querido-custom-spanish-lyric-swap-hero.webp`,
    blogSlug: "mexico-lindo-y-querido-custom-spanish-lyric-swap",
  },
  {
    slug: "brandy-youre-a-fine-girl-custom-name-swap",
    songName: "Brandy You're a Fine Girl (Looking Glass)",
    clientDisplay: "Keith S.",
    projectType: "Gift",
    description: "Looking Glass's classic harbor town ballad with Brandy changed to Mandy throughout. A seamless name swap that keeps the sailor story intact.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/brandy-youre-a-fine-girl-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/brandy-youre-a-fine-girl-custom-name-swap-hero.webp`,
    blogSlug: "brandy-youre-a-fine-girl-custom-name-swap",
    rating: 5,
  },
  {
    slug: "somewhere-along-the-way-daddy-daughter-wedding-song",
    songName: "Somewhere Along The Way (Eddie Dalton)",
    clientDisplay: "Gil D.",
    projectType: "Wedding",
    description: "Eddie Dalton's reflective ballad on aging transformed into a father-daughter wedding dance. Every pronoun flipped from self to daughter.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/somewhere-along-the-way-daddy-daughter-wedding-song-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/somewhere-along-the-way-daddy-daughter-wedding-song-hero.webp`,
    blogSlug: "somewhere-along-the-way-daddy-daughter-wedding-song",
    rating: 5,
  },
  {
    slug: "when-im-sixty-four-custom-birthday-lyrics",
    songName: "When I'm Sixty-Four (The Beatles)",
    clientDisplay: "TJ O.",
    projectType: "Celebration",
    description: "The Beatles' classic birthday anthem with pronouns flipped and details personalized for a 64th birthday celebration.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/when-im-sixty-four-custom-birthday-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/when-im-sixty-four-custom-birthday-lyrics-hero.webp`,
    blogSlug: "when-im-sixty-four-custom-birthday-lyrics",
  },
  {
    slug: "o-fortuna-custom-grandchild-gift-lyrics",
    songName: "O Fortuna (Carl Orff)",
    clientDisplay: "Sandra M.",
    projectType: "Gift",
    description: "Carl Orff's apocalyptic Latin choral piece rewritten as a playful packing song for a grandchild's trip to Grandma's. A swap on a 100% vocal track with no separable instrumental.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/o-fortuna-custom-grandchild-gift-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/o-fortuna-custom-grandchild-gift-lyrics-hero.webp`,
    blogSlug: "o-fortuna-custom-grandchild-gift-lyrics",
    rating: 5,
  },
  {
    slug: "adios-pampa-mia-custom-personal-lyric-swap",
    songName: "Adios Pampa Mia (Julio Iglesias)",
    clientDisplay: "Bruno",
    projectType: "Personal",
    description: "Julio Iglesias's Argentine farewell tango gets a surgical two-word phrase change using ChangeLyric's Horizon section-edit engine. Tiny swap, tight seam, original vocal character preserved.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/adios-pampa-mia-custom-personal-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/adios-pampa-mia-custom-personal-lyric-swap-hero.webp`,
    blogSlug: "adios-pampa-mia-custom-personal-lyric-swap",
    rating: 5,
  },
  {
    slug: "hot-wheels-crossfields-team-anthem",
    songName: "Hot Wheels (Theme)",
    clientDisplay: "Kevin S.",
    projectType: "Celebration",
    description: "The Hot Wheels TV theme rebuilt into a walk-out hype anthem for a youth team called the Crossfields. A few targeted word swaps turn a TV jingle into a fight song.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/hot-wheels-crossfields-team-anthem-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/hot-wheels-crossfields-team-anthem-hero.webp`,
    blogSlug: "hot-wheels-crossfields-team-anthem",
    rating: 5,
  },
  {
    slug: "london-calling-solana-crypto-parody",
    songName: "London Calling (The Clash)",
    clientDisplay: "Kieran O.",
    projectType: "Personal",
    description: "The Clash's punk anthem transformed into 'Solana Calling,' a cryptocurrency parody where punk rock energy meets blockchain culture.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/london-calling-solana-crypto-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/london-calling-solana-crypto-parody-hero.webp`,
    blogSlug: "london-calling-solana-crypto-parody",
  },
  {
    slug: "wake-me-up-september-ends-custom-lyrics",
    songName: "Wake Me Up When September Ends",
    clientDisplay: "Douglas H.",
    projectType: "Celebration",
    description: "Green Day's iconic anthem personalized for a family event, honoring 50 years of brotherhood with subtle pronoun and timeline changes.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/wake-me-up-september-ends-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/wake-me-up-september-ends-custom-lyrics-hero.webp`,
    blogSlug: "wake-me-up-september-ends-custom-lyrics",
    rating: 5,
  },
  {
    slug: "hell-yeah-she-did-neil-diamond-tribute",
    songName: "Hell Yeah (Neil Diamond)",
    clientDisplay: "Faye J.",
    projectType: "Celebration",
    description: "Every 'he' became 'she' in this Neil Diamond classic, transforming it into a Celebration of Life tribute for a beloved mother.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/hell-yeah-she-did-neil-diamond-tribute-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/hell-yeah-she-did-neil-diamond-tribute-hero.webp`,
    blogSlug: "hell-yeah-she-did-neil-diamond-tribute",
    rating: 5,
  },
  {
    slug: "shake-it-off-custom-graduation-lyrics",
    songName: "Shake It Off (Taylor Swift)",
    clientDisplay: "Yvonne O.",
    projectType: "Celebration",
    description: "Taylor Swift's Shake It Off completely rewritten to celebrate UCSF ophthalmology fellows by name for a graduation video.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/shake-it-off-custom-graduation-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/shake-it-off-custom-graduation-lyrics-hero.webp`,
    blogSlug: "shake-it-off-custom-graduation-lyrics",
    rating: 5,
  },
  {
    slug: "gracie-custom-wedding-name-swap",
    songName: "Gracie (Ben Platt)",
    clientDisplay: "Stuart C.",
    projectType: "Wedding",
    description: "Ben Platt's Gracie with the name changed to Jamie for a father-daughter wedding dance.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/gracie-custom-wedding-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/gracie-custom-wedding-name-swap-hero.webp`,
    blogSlug: "gracie-custom-wedding-name-swap",
    rating: 5,
  },
  {
    slug: "babys-got-her-blue-jeans-on-custom-lyrics",
    songName: "Baby's Got Her Blue Jeans On",
    clientDisplay: "Howard B.",
    projectType: "Personal",
    description: "Mel McDaniel's classic with blue jeans changed to green dress throughout. Five swaps, completely seamless.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/babys-got-her-blue-jeans-on-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/babys-got-her-blue-jeans-on-custom-lyrics-hero.webp`,
    blogSlug: "babys-got-her-blue-jeans-on-custom-lyrics",
    rating: 5,
  },
  {
    slug: "pink-pony-club-custom-corporate-lyrics",
    songName: "Pink Pony Club (Chappell Roan)",
    clientDisplay: "Christian B.",
    projectType: "Corporate",
    description: "Chappell Roan's Pink Pony Club rewritten as a corporate parody for a company all-hands meeting, swapping West Hollywood for Strat Ops Club.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/pink-pony-club-custom-corporate-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/pink-pony-club-custom-corporate-lyrics-hero.webp`,
    blogSlug: "pink-pony-club-custom-corporate-lyrics",
    rating: 5,
  },
  {
    slug: "since-youve-been-gone-ai-vocal-fix",
    songName: "Since You've Been Gone",
    clientDisplay: "Michael K.",
    projectType: "Personal",
    description: "An AI-generated vocal with mispronunciations corrected and a brand new verse added to deepen the emotional arc.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/since-youve-been-gone-ai-vocal-fix-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/since-youve-been-gone-ai-vocal-fix-hero.webp`,
    blogSlug: "since-youve-been-gone-ai-vocal-fix",
    rating: 5,
  },
  {
    slug: "girls-rachel-platten-custom-name-swap",
    songName: "Girls (Rachel Platten)",
    clientDisplay: "Megan M.",
    projectType: "Gift",
    description: "Rachel Platten's Girls personalized with a child's name, turning a universal anthem into a direct message from mother to child.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/girls-rachel-platten-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/girls-rachel-platten-custom-name-swap-hero.webp`,
    blogSlug: "girls-rachel-platten-custom-name-swap",
    rating: 5,
  },
  {
    slug: "thank-you-for-the-music-abba-football-parody",
    songName: "Thank You For The Music (ABBA)",
    clientDisplay: "Jason S.",
    projectType: "Celebration",
    description: "ABBA's Thank You For The Music rewritten as Thank You For The Losses, a hilarious football club parody anthem.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/thank-you-for-the-music-abba-football-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/thank-you-for-the-music-abba-football-parody-hero.webp`,
    blogSlug: "thank-you-for-the-music-abba-football-parody",
    rating: 5,
  },
  {
    slug: "i-believe-in-joe-hendry-custom-name-swap",
    songName: "I Believe In Joe Hendry",
    clientDisplay: "Nick M.",
    projectType: "Gift",
    description: "The viral wrestling entrance anthem with Joe Hendry swapped for a custom name, creating a personalized hype track.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/i-believe-in-joe-hendry-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/i-believe-in-joe-hendry-custom-name-swap-hero.webp`,
    blogSlug: "i-believe-in-joe-hendry-custom-name-swap",
  },
  {
    slug: "im-so-proud-of-you-custom-wedding-lyrics",
    songName: "I'm So Proud of You",
    clientDisplay: "Lisa G.",
    projectType: "Wedding",
    description: "A faith-based anthem personalized for a mother-daughter wedding dance, with gendered pronouns updated, the daughter's name woven in, and a family pet name added to the bridge.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/im-so-proud-of-you-custom-wedding-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/im-so-proud-of-you-custom-wedding-lyrics-hero.webp`,
    blogSlug: "im-so-proud-of-you-custom-wedding-lyrics",
    rating: 5,
  },
  {
    slug: "ik-ben-een-vent-jimmy-frey-custom-name-swap",
    songName: "Ik Ben Een Vent (Jimmy Frey)",
    clientDisplay: "Thomas V.",
    projectType: "Gift",
    description: "A beloved Flemish classic rewritten from self-praise into a personal tribute, with the subject's name woven throughout in natural Flemish diminutives.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ik-ben-een-vent-jimmy-frey-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ik-ben-een-vent-jimmy-frey-custom-name-swap-hero.webp`,
    blogSlug: "ik-ben-een-vent-jimmy-frey-custom-name-swap",
    rating: 5,
  },
  {
    slug: "cult-of-personality-living-colour-pharmacy-parody",
    songName: "Cult of Personality (Living Colour)",
    clientDisplay: "Jeff P.",
    projectType: "Corporate",
    description: "Living Colour's iconic rock anthem fully rewritten as Cult of Hospitality, a pharmacy team parody with industry references replacing political ones.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/cult-of-personality-living-colour-pharmacy-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/cult-of-personality-living-colour-pharmacy-parody-hero.webp`,
    blogSlug: "cult-of-personality-living-colour-pharmacy-parody",
    rating: 5,
  },
  {
    slug: "best-friend-custom-pet-memorial-name-swap",
    songName: "Best Friend",
    clientDisplay: "Nick V.",
    projectType: "Celebration",
    description: "A country ballad about losing a dog, personalized with the name Daisy for a pet memorial tribute video.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/best-friend-custom-pet-memorial-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/best-friend-custom-pet-memorial-name-swap-hero.webp`,
    blogSlug: "best-friend-custom-pet-memorial-name-swap",
    rating: 5,
  },
  {
    slug: "sail-away-custom-pronoun-swap",
    songName: "Sail Away",
    clientDisplay: "Bess W.",
    projectType: "Personal",
    description: "A nautical ballad about waiting for loved ones, personalized from plural to singular pronouns to focus on one person's tribute.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/sail-away-custom-pronoun-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/sail-away-custom-pronoun-swap-hero.webp`,
    blogSlug: "sail-away-custom-pronoun-swap",
    rating: 5,
  },
  {
    slug: "harbor-lights-custom-lyric-swap",
    songName: "Harbor Lights",
    clientDisplay: "Bess W.",
    projectType: "Personal",
    description: "A folk ballad about finding your way home, with three key lines rewritten to reshape the narrator's journey from loss to declaration.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/harbor-lights-custom-lyric-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/harbor-lights-custom-lyric-swap-hero.webp`,
    blogSlug: "harbor-lights-custom-lyric-swap",
    rating: 5,
  },
  {
    slug: "we-are-the-champions-custom-corporate-tribute",
    songName: "We Are The Champions (Queen)",
    clientDisplay: "Iconsult",
    projectType: "Corporate",
    description: "Queen's We Are The Champions personalized as Josh Is The Champion for a corporate tribute event.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/we-are-the-champions-custom-corporate-tribute-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/we-are-the-champions-custom-corporate-tribute-hero.webp`,
    blogSlug: "we-are-the-champions-custom-corporate-tribute",
  },
  {
    slug: "eye-of-the-tiger-custom-corporate-lyrics",
    songName: "Eye of the Tiger (Survivor)",
    clientDisplay: "Narva",
    projectType: "Corporate",
    description: "Survivor's Eye of the Tiger with every chorus rewritten for a Swedish company's team event.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/eye-of-the-tiger-custom-corporate-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/eye-of-the-tiger-custom-corporate-lyrics-hero.webp`,
    blogSlug: "eye-of-the-tiger-custom-corporate-lyrics",
  },
  {
    slug: "tennessee-orange-megan-moroney-corporate-parody",
    songName: "Tennessee Orange (Megan Moroney)",
    clientDisplay: "Liberty Energy",
    projectType: "Corporate",
    description: "Megan Moroney's Tennessee Orange rewritten as Colorado Gold, swapping every state reference from Tennessee to Colorado for a corporate event.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/tennessee-orange-megan-moroney-corporate-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/tennessee-orange-megan-moroney-corporate-parody-hero.webp`,
    blogSlug: "tennessee-orange-megan-moroney-corporate-parody",
  },
  {
    slug: "human-the-killers-solidcam-corporate-parody",
    songName: "Human (The Killers)",
    clientDisplay: "Macondia",
    projectType: "Corporate",
    description: "The Killers' Human completely rewritten as a SolidCAM corporate anthem, turning existential synth-rock into manufacturing industry pride.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/human-the-killers-solidcam-corporate-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/human-the-killers-solidcam-corporate-parody-hero.webp`,
    blogSlug: "human-the-killers-solidcam-corporate-parody",
  },
  {
    slug: "im-so-excited-pointer-sisters-corporate-parody",
    songName: "I'm So Excited (Pointer Sisters)",
    clientDisplay: "Stow-Group",
    projectType: "Corporate",
    description: "The Pointer Sisters' I'm So Excited rewritten as Stow Excited, a tribute to a CEO's 35-year tenure at a global logistics company.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/im-so-excited-pointer-sisters-corporate-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/im-so-excited-pointer-sisters-corporate-parody-hero.webp`,
    blogSlug: "im-so-excited-pointer-sisters-corporate-parody",
  },
  {
    slug: "unstoppable-sia-towersemi-corporate-parody",
    songName: "Unstoppable (Sia)",
    clientDisplay: "TowerSemi",
    projectType: "Corporate",
    description: "Sia's Unstoppable rewritten as a semiconductor team anthem, shifting every pronoun from solo confidence to collective corporate pride.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/unstoppable-sia-towersemi-corporate-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/unstoppable-sia-towersemi-corporate-parody-hero.webp`,
    blogSlug: "unstoppable-sia-towersemi-corporate-parody",
  },
  {
    slug: "ymca-village-people-jotun-corporate-parody",
    songName: "Y.M.C.A. (Village People)",
    clientDisplay: "Jotun",
    projectType: "Corporate",
    description: "The Village People's YMCA rewritten as YCCA for Jotun's corporate services division, turning a disco classic into a shared services anthem.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ymca-village-people-jotun-corporate-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ymca-village-people-jotun-corporate-parody-hero.webp`,
    blogSlug: "ymca-village-people-jotun-corporate-parody",
  },
  {
    slug: "opp-naughty-by-nature-plumbing-parody",
    songName: "O.P.P. (Naughty By Nature)",
    clientDisplay: "Crow's Plumbing",
    projectType: "Corporate",
    description: "Naughty By Nature's O.P.P. rewritten as S.P.P. — a plumbing service plan parody for marketing, turning hip-hop swagger into homeowner sales.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/opp-naughty-by-nature-plumbing-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/opp-naughty-by-nature-plumbing-parody-hero.webp`,
    blogSlug: "opp-naughty-by-nature-plumbing-parody",
  },
  {
    slug: "hot-to-go-chappell-roan-caplico-corporate-parody",
    songName: "HOT TO GO! (Chappell Roan)",
    clientDisplay: "Ensign Services",
    projectType: "Corporate",
    description: "Chappell Roan's HOT TO GO! with the letter-spelling hook swapped to CAPLICO, turning a viral pop anthem into a corporate values chant.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/hot-to-go-chappell-roan-caplico-corporate-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/hot-to-go-chappell-roan-caplico-corporate-parody-hero.webp`,
    blogSlug: "hot-to-go-chappell-roan-caplico-corporate-parody",
  },
  {
    slug: "superwoman-karyn-white-custom-empowerment-lyrics",
    songName: "Superwoman (Karyn White)",
    clientDisplay: "Van den Bogaard",
    projectType: "Personal",
    description: "Karyn White's Superwoman with key lines flipped from defeat to empowerment, turning resignation into a declaration of strength.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/superwoman-karyn-white-custom-empowerment-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/superwoman-karyn-white-custom-empowerment-lyrics-hero.webp`,
    blogSlug: "superwoman-karyn-white-custom-empowerment-lyrics",
  },
  {
    slug: "ophelia-lumineers-custom-name-swap",
    songName: "Ophelia (The Lumineers)",
    clientDisplay: "Quentin Z.",
    projectType: "Wedding",
    description: "The Lumineers' Ophelia with every instance of the name changed to Aryana, plus pronoun adjustments for a personal dedication.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ophelia-lumineers-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ophelia-lumineers-custom-name-swap-hero.webp`,
    blogSlug: "ophelia-lumineers-custom-name-swap",
  },
  {
    slug: "rhiannon-fleetwood-mac-custom-name-swap",
    songName: "Rhiannon (Fleetwood Mac)",
    clientDisplay: "Brandon S.",
    projectType: "Wedding",
    description: "Fleetwood Mac's Rhiannon with every instance of the name swapped to Savannah, a perfect three-syllable phonetic match.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/rhiannon-fleetwood-mac-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/rhiannon-fleetwood-mac-custom-name-swap-hero.webp`,
    blogSlug: "rhiannon-fleetwood-mac-custom-name-swap",
  },
  {
    slug: "jack-and-diane-john-mellencamp-custom-lyrics",
    songName: "Jack & Diane (John Mellencamp)",
    clientDisplay: "Chris S.",
    projectType: "Gift",
    description: "John Mellencamp's Jack & Diane fully rewritten as Jack and Frankie, turning a teenage romance into a twin brothers' tribute to Mom.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/jack-and-diane-john-mellencamp-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/jack-and-diane-john-mellencamp-custom-lyrics-hero.webp`,
    blogSlug: "jack-and-diane-john-mellencamp-custom-lyrics",
  },
  {
    slug: "prodigal-son-ai-vocal-fix",
    songName: "Prodigal Son",
    clientDisplay: "Harden",
    projectType: "Personal",
    description: "An AI-generated song where \"prodigal\" was mispronounced as \"protocol\" throughout, corrected across every chorus and hook.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/prodigal-son-ai-vocal-fix-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/prodigal-son-ai-vocal-fix-hero.webp`,
    blogSlug: "prodigal-son-ai-vocal-fix",
  },
  {
    slug: "mandy-barry-manilow-custom-name-swap",
    songName: "Mandy (Barry Manilow)",
    clientDisplay: "Luc M.",
    projectType: "Wedding",
    description: "Barry Manilow's Mandy with every instance of the name swapped to Wendy, a seamless two-syllable phonetic match across every chorus.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/mandy-barry-manilow-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/mandy-barry-manilow-custom-name-swap-hero.webp`,
    blogSlug: "mandy-barry-manilow-custom-name-swap",
  },
  {
    slug: "love-hurts-nazareth-custom-parody-lyrics",
    songName: "Love Hurts (Nazareth)",
    clientDisplay: "Peter K.",
    projectType: "Personal",
    description: "Nazareth's Love Hurts fully rewritten as Leg Hurts, an absurdist parody replacing heartbreak with limbs, goblins, and gravity.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/love-hurts-nazareth-custom-parody-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/love-hurts-nazareth-custom-parody-lyrics-hero.webp`,
    blogSlug: "love-hurts-nazareth-custom-parody-lyrics",
  },
  {
    slug: "ex-wives-six-musical-custom-fantasy-rewrite",
    songName: "Ex-Wives (SIX the Musical)",
    clientDisplay: "Elaine E.",
    projectType: "Personal",
    description: "SIX the Musical's Ex-Wives fully rewritten with fantasy characters, replacing Henry VIII's queens with original heroines in a new universe.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ex-wives-six-musical-custom-fantasy-rewrite-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ex-wives-six-musical-custom-fantasy-rewrite-hero.webp`,
    blogSlug: "ex-wives-six-musical-custom-fantasy-rewrite",
  },
  {
    slug: "whole-lives-jake-scott-custom-wedding-lyrics",
    songName: "Whole Lives (Jake Scott)",
    clientDisplay: "Abigail W.",
    projectType: "Wedding",
    description: "Jake Scott's Whole Lives with the proposal scene personalized — Paris became rain, a letter became a jersey, matching how it really happened.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/whole-lives-jake-scott-custom-wedding-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/whole-lives-jake-scott-custom-wedding-lyrics-hero.webp`,
    blogSlug: "whole-lives-jake-scott-custom-wedding-lyrics",
  },
  {
    slug: "a-little-sacrifice-witcher-custom-rewrite",
    songName: "A Little Sacrifice (The Witcher)",
    clientDisplay: "Tom P.",
    projectType: "Personal",
    description: "The Witcher's A Little Sacrifice fully rewritten with custom fantasy lore, replacing sirens and princes with original wartime characters.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/a-little-sacrifice-witcher-custom-rewrite-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/a-little-sacrifice-witcher-custom-rewrite-hero.webp`,
    blogSlug: "a-little-sacrifice-witcher-custom-rewrite",
  },
  {
    slug: "grow-old-with-you-wedding-singer-gender-swap",
    songName: "Grow Old With You (The Wedding Singer)",
    clientDisplay: "David S.",
    projectType: "Wedding",
    description: "Grow Old With You from The Wedding Singer with a single word changed — \"man\" to \"woman\" — for a wedding celebration.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/grow-old-with-you-wedding-singer-gender-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/grow-old-with-you-wedding-singer-gender-swap-hero.webp`,
    blogSlug: "grow-old-with-you-wedding-singer-gender-swap",
  },
  {
    slug: "in-der-weihnachtsbackerei-custom-name-swap",
    songName: "In der Weihnachtsbäckerei (Rolf Zuckowski)",
    clientDisplay: "Claus G.",
    projectType: "Gift",
    description: "Rolf Zuckowski's beloved German Christmas baking song with every \"Weihnachtsbäckerei\" swapped to \"Christinas Bäckerei\" for a personal holiday gift.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/in-der-weihnachtsbackerei-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/in-der-weihnachtsbackerei-custom-name-swap-hero.webp`,
    blogSlug: "in-der-weihnachtsbackerei-custom-name-swap",
  },
  {
    slug: "jolene-dolly-parton-custom-name-swap",
    songName: "Jolene (Dolly Parton)",
    clientDisplay: "Kyle P.",
    projectType: "Wedding",
    description: "Dolly Parton's Jolene with every instance of the name swapped to Janine, over twenty replacements across the entire track.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/jolene-dolly-parton-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/jolene-dolly-parton-custom-name-swap-hero.webp`,
    blogSlug: "jolene-dolly-parton-custom-name-swap",
  },
  {
    slug: "pokemon-french-theme-custom-lyrics",
    songName: "Pokémon (French Theme)",
    clientDisplay: "Mehdi A.",
    projectType: "Personal",
    description: "The iconic French Pokémon anime theme transformed into a hilarious hair transplant anthem. A complete thematic overhaul from Pokémon trainer to baldness conqueror.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/pokemon-french-theme-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/pokemon-french-theme-custom-lyrics-hero.webp`,
    blogSlug: "pokemon-french-theme-custom-lyrics",
  },
  {
    slug: "tujh-mein-rab-dikhta-hai-custom-name-swap",
    songName: "Tujh Mein Rab Dikhta Hai",
    clientDisplay: "Ejaz E.",
    projectType: "Wedding",
    description: "The beloved Bollywood classic from Rab Ne Bana Di Jodi with a precise name swap from 'Rab' to 'Sab,' transforming spiritual devotion into personalized adoration.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/tujh-mein-rab-dikhta-hai-custom-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/tujh-mein-rab-dikhta-hai-custom-name-swap-hero.webp`,
    blogSlug: "tujh-mein-rab-dikhta-hai-custom-name-swap",
  },
  {
    slug: "red-kingdom-red-raiders-team-anthem",
    songName: "Red Kingdom",
    clientDisplay: "Drew H.",
    projectType: "Personal",
    description: "Tech N9ne's Kansas City Chiefs anthem transformed into a Texas Tech Red Raiders fight song, swapping NFL stars for college football legends.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/red-kingdom-red-raiders-team-anthem-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/red-kingdom-red-raiders-team-anthem-hero.webp`,
    blogSlug: "red-kingdom-red-raiders-team-anthem",
  },
  {
    slug: "stacys-mom-my-kids-mom-family-tribute",
    songName: "Stacy's Mom",
    clientDisplay: "Ronny L.",
    projectType: "Gift",
    description: "Fountains of Wayne's cheeky pop hit transformed into a heartfelt tribute to a wife and mother of six boys, flipping teenage longing into mature gratitude.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/stacys-mom-my-kids-mom-family-tribute-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/stacys-mom-my-kids-mom-family-tribute-hero.webp`,
    blogSlug: "stacys-mom-my-kids-mom-family-tribute",
  },
  {
    slug: "all-summer-long-clean-family-version",
    songName: "All Summer Long",
    clientDisplay: "Harry T.",
    projectType: "Personal",
    description: "Kid Rock's nostalgic summer anthem transformed into a family-friendly version, swapping whiskey for Pepsi and making love for dancing.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/all-summer-long-clean-family-version-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/all-summer-long-clean-family-version-hero.webp`,
    blogSlug: "all-summer-long-clean-family-version",
  },
  {
    slug: "hold-back-the-river-custom-wedding-lyrics",
    songName: "Hold Back The River (James Bay)",
    clientDisplay: "Daniel N.",
    projectType: "Wedding" as const,
    description: "James Bay's Hold Back The River transformed into a wedding dedication, turning 'Hold back the river' into 'Flow with the river' and 'Lonely water' into 'Lovely Anna, let us marry each other.'",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/hold-back-the-river-custom-wedding-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/hold-back-the-river-custom-wedding-lyrics-hero.webp`,
    blogSlug: "hold-back-the-river-custom-wedding-lyrics",
  },
  {
    slug: "lonely-day-custom-positive-lyrics",
    songName: "Lonely Day (System of a Down)",
    clientDisplay: "Jonathan S.",
    projectType: "Personal",
    description: "System of a Down's melancholy hit completely inverted into a celebration of gratitude, swapping lonely for lovely and despair for joy.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/lonely-day-custom-positive-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/lonely-day-custom-positive-lyrics-hero.webp`,
    blogSlug: "lonely-day-custom-positive-lyrics",
  },
  {
    slug: "happy-birthday-custom-wedding-version",
    songName: "Happy Birthday (Pop Ballad)",
    clientDisplay: "Enrique M.",
    projectType: "Wedding" as const,
    description: "A pop birthday ballad transformed into a wedding gift from brother to sister, swapping birthday wishes for marriage celebrations across two distinct choruses.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/happy-birthday-custom-wedding-version-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/happy-birthday-custom-wedding-version-hero.webp`,
    blogSlug: "happy-birthday-custom-wedding-version",
  },
  {
    slug: "gitano-tu-gitana-yo-lola-flores-custom-lyrics",
    songName: "Gitano Tu, Gitana Yo (Lola Flores)",
    clientDisplay: "Raul G.",
    projectType: "Personal",
    description: "Lola Flores' flamenco protest anthem transformed from a plea for explanation into a declaration of pride, swapping 'explíqueme' for 'escuche usted.'",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/gitano-tu-gitana-yo-lola-flores-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/gitano-tu-gitana-yo-lola-flores-custom-lyrics-hero.webp`,
    blogSlug: "gitano-tu-gitana-yo-lola-flores-custom-lyrics",
  },
  {
    slug: "jugar-por-jugar-joaquin-sabina-custom-lyrics",
    songName: "Jugar Por Jugar (Joaquín Sabina)",
    clientDisplay: "Raul G.",
    projectType: "Gift",
    description: "Joaquín Sabina's poetic anthem rewritten with personal childhood memories of first love by the river, while preserving the iconic 'jugar por jugar' chorus.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/jugar-por-jugar-joaquin-sabina-custom-lyrics-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/jugar-por-jugar-joaquin-sabina-custom-lyrics-hero.webp`,
    blogSlug: "jugar-por-jugar-joaquin-sabina-custom-lyrics",
  },
  {
    slug: "mambo-no-5-baby-no-5-parody",
    songName: "Mambo No. 5",
    clientDisplay: "Kyle H.",
    projectType: "Personal",
    description: "Lou Bega's party anthem transformed into a celebration of new parenthood, swapping women's names for baby experiences.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/mambo-no-5-baby-no-5-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/mambo-no-5-baby-no-5-parody-hero.webp`,
    blogSlug: "mambo-no-5-baby-no-5-parody",
    rating: 5,
  },
  {
    slug: "gloria-real-estate-parody",
    songName: "Gloria",
    clientDisplay: "LoBaido",
    projectType: "Personal",
    description: "Laura Branigan's 80s classic transformed into a real estate negotiation anthem about buying a house from a neighbor.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/gloria-real-estate-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/gloria-real-estate-parody-hero.webp`,
    blogSlug: "gloria-real-estate-parody",
  },
  {
    slug: "just-fishin-just-skiing-outdoor-parody",
    songName: "Just Fishin' (Trace Adkins)",
    clientDisplay: "Rachel B.",
    projectType: "Personal",
    description: "Trace Adkins' heartwarming father-daughter fishing anthem transformed into a skiing adventure on the slopes.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/just-fishin-just-skiing-outdoor-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/just-fishin-just-skiing-outdoor-parody-hero.webp`,
    blogSlug: "just-fishin-just-skiing-outdoor-parody",
  },
  {
    slug: "just-cant-get-enough-corporate-data-parody",
    songName: "Just Can't Get Enough (Depeche Mode)",
    clientDisplay: "Lindsay M.",
    projectType: "Corporate",
    description: "Depeche Mode's iconic 80s synth-pop anthem transformed into a corporate data analytics celebration.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/just-cant-get-enough-corporate-data-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/just-cant-get-enough-corporate-data-parody-hero.webp`,
    blogSlug: "just-cant-get-enough-corporate-data-parody",
  },
  {
    slug: "how-am-i-supposed-flex-without-you-pt-parody",
    songName: "How Am I Supposed to Live Without You (Michael Bolton)",
    clientDisplay: "Tim O S.",
    projectType: "Personal",
    description: "Michael Bolton's power ballad transformed into a physical therapy anthem about determination and recovery.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/how-am-i-supposed-flex-without-you-pt-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/how-am-i-supposed-flex-without-you-pt-parody-hero.webp`,
    blogSlug: "how-am-i-supposed-flex-without-you-pt-parody",
  },
  {
    slug: "sara-smile-takierra-name-swap",
    songName: "Sara Smile (Hall & Oates)",
    clientDisplay: "Brian H.",
    projectType: "Wedding",
    description: "Hall & Oates' soulful classic with every instance of Sara changed to Takierra, preserving the original's intimate warmth.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/sara-smile-takierra-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/sara-smile-takierra-name-swap-hero.webp`,
    blogSlug: "sara-smile-takierra-name-swap",
  },
  {
    slug: "count-on-me-daddy-version",
    songName: "Count On Me (Bruno Mars)",
    clientDisplay: "Mattingly",
    projectType: "Gift",
    description: "Bruno Mars' friendship anthem transformed into a father-child dedication by swapping 'friends' to 'daddy' throughout the track.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/count-on-me-daddy-version-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/count-on-me-daddy-version-hero.webp`,
    blogSlug: "count-on-me-daddy-version",
  },
  {
    slug: "mississippi-california-geographic-swap",
    songName: "One Mississippi",
    clientDisplay: "Dan S.",
    projectType: "Personal",
    description: "A song originally about Mississippi transformed into a California anthem. Geographic references shift from the Mississippi River to the Pacific Coast.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/mississippi-california-geographic-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/mississippi-california-geographic-swap-hero.webp`,
    blogSlug: "mississippi-california-geographic-swap",
  },
  {
    slug: "best-parts-of-me-detail-swap",
    songName: "Best Parts of Me (Will Dempsey)",
    clientDisplay: "EXTREME PERFORMANCE",
    projectType: "Personal",
    description: "A father-daughter song personalized with specific characteristics: brown eyes become green, pink dress becomes white, brown hair becomes blonde.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/best-parts-of-me-detail-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/best-parts-of-me-detail-swap-hero.webp`,
    blogSlug: "best-parts-of-me-detail-swap",
  },
  {
    slug: "song-for-mama-wendy-name-swap",
    songName: "A Song for Mama (Boyz II Men)",
    clientDisplay: "Ernie S.",
    projectType: "Gift",
    description: "Boyz II Men's timeless 'A Song for Mama' transformed into a personal dedication by swapping 'Mama' for 'Wendy' throughout the track.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/song-for-mama-wendy-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/song-for-mama-wendy-name-swap-hero.webp`,
    blogSlug: "song-for-mama-wendy-name-swap",
  },
  {
    slug: "little-miss-magic-carmen-name-swap",
    songName: "Little Miss Magic (Jimmy Buffett)",
    clientDisplay: "Todd P.",
    projectType: "Gift",
    description: "Jimmy Buffett's tender ballad about fatherhood personalized by changing the daughter's name to Carmen, creating a direct love letter from father to child.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/little-miss-magic-carmen-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/little-miss-magic-carmen-name-swap-hero.webp`,
    blogSlug: "little-miss-magic-carmen-name-swap",
  },
  {
    slug: "growing-up-raising-you-teaching-version",
    songName: "Growing Up Raising You (Gabby Barrett)",
    clientDisplay: "Becky C.",
    projectType: "Personal",
    description: "Gabby Barrett's parenting ballad transformed into a teacher's anthem by swapping 'raising' to 'teaching,' reframing the entire song from parent-child to teacher-student.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/growing-up-raising-you-teaching-version-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/growing-up-raising-you-teaching-version-hero.webp`,
    blogSlug: "growing-up-raising-you-teaching-version",
  },
  {
    slug: "dela-raya-name-swap",
    songName: "Dela (Johnny Clegg)",
    clientDisplay: "John W.",
    projectType: "Wedding",
    description: "Johnny Clegg's iconic world music classic transformed with a name swap from Dela to Raya, preserving the song's Zulu-inspired beauty while creating a deeply personal dedication.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/dela-raya-name-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/dela-raya-name-swap-hero.webp`,
    blogSlug: "dela-raya-name-swap",
  },
  {
    slug: "the-mother-will-and-eve-names-swap",
    songName: "The Mother (Brandi Carlile)",
    clientDisplay: "Lisa H.",
    projectType: "Gift",
    description: "Brandi Carlile's deeply personal song about motherhood transformed from a single-daughter dedication into a celebration of twin motherhood for Will and Eve.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/the-mother-will-and-eve-names-swap-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/the-mother-will-and-eve-names-swap-hero.webp`,
    blogSlug: "the-mother-will-and-eve-names-swap",
  },
  {
    slug: "ring-ring-bling-bling-parody",
    songName: "Ring Ring",
    clientDisplay: "Melissa G.",
    projectType: "Personal",
    description: "Ring Ring (originally by ABBA but performed by The Rasmus in this version) transformed into 'Bling Bling,' a whimsical parody that swaps 'ring' for 'bling' and 'drink' throughout.",
    deliveredAudioUrl: `${R2_BASE}/showcase-audio/ring-ring-bling-bling-parody-delivered.mp3`,
    heroImageUrl: `${R2_BASE}/ring-ring-bling-bling-parody-hero.webp`,
    blogSlug: "ring-ring-bling-bling-parody",
  },
];

export const projectTypes: ProjectType[] = ["Corporate", "Wedding", "Gift", "Religious", "Celebration", "Personal"];
